import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { ProductDiscount } from 'src/app/entities/product-discount';
import { ProductDiscountService } from 'src/app/services/product-discount.service';
import { BaseAddComponent } from '../base-add/base-add.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-product-discount-add',
  templateUrl: './product-discount-add.component.html',
  styleUrls: ['./product-discount-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ProductDiscountAddComponent extends BaseAddComponent<ProductDiscount> implements OnInit {

  pathUrlList = 'product-discount';
  categoriesParents = new Array<ProductDiscount>();

  constructor(
    protected discountService: ProductDiscountService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = discountService;
    this.item = new ProductDiscount();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'product_id',
        title: 'Producto_ID',
        caption: ''
      },      
      {
        type: 'string',
        key: 'percent',
        title: 'Porcentaje',
        caption: ''
      },
      {
        type: 'string',
        key: 'from',
        title: 'Desde (YYYY-MM-DD)',
        caption: '',
        placeholder: 'YYYY-MM-DD'
      },
      {
        type: 'string',
        key: 'to',
        title: 'Hasta (YYYY-MM-DD)',
        caption: '',
        placeholder: 'YYYY-MM-DD'
      },
      {
        type: 'select',
        key: 'status',
        title: 'Activo',
        caption: '',
        options: [
          {
            title: 'SI',
            value: 1
          },
          {
            title: 'NO',
            value: 0
          }
        ]
      }
    ];
  }

}